// ============================================================================
// UPLOAD API - Frontend
// getLogoUrl devuelve URL relativa para que Vite la proxie al backend.
// El proxy /uploads → http://backend:3000 está configurado en vite.config.ts
// ============================================================================

const ACCESS_TOKEN_KEY = 'imi_access_token';

export async function uploadLogo(file: File): Promise<string> {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY) || '';
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch('/api/v1/upload/logo', {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err?.message || `Error al subir el logo (${response.status})`);
  }

  const data = await response.json();
  return data.url as string; // p.ej. /uploads/logos/logo-123.jpg
}

export async function deleteLogo(url: string): Promise<void> {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY) || '';
  await fetch('/api/v1/upload/logo', {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ url }),
  });
}

/**
 * Devuelve la URL para usar en <img src>.
 * URLs relativas (/uploads/...) se sirven via el proxy de Vite → backend.
 * URLs absolutas (http://...) se devuelven tal cual.
 */
export function getLogoUrl(relativeUrl: string | null | undefined): string | null {
  if (!relativeUrl) return null;
  return relativeUrl; // relativa o absoluta, funciona en ambos casos
}
